// extracted by mini-css-extract-plugin
export default {"container":"BudgetComponentDetails_container__tVVid"};